import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import managerSlices, { type ManagerSlices } from './slices';

const devtoolsInstance = devtools(managerSlices, {
  name: 'useBussinessManagerStore',
});

const useUpsellModalStore = create<ManagerSlices, [['zustand/devtools', never]]>(devtoolsInstance);

export default useUpsellModalStore;
